import { PageHeader } from "@/components/shared";
import { Card } from "@/components/ui/card";
import { Rocket } from "lucide-react";

export default function ComingSoon({ title, phase }) {
  return (
    <div>
      <PageHeader title={title} />
      <Card className="p-10 flex flex-col items-center text-center">
        <div className="h-14 w-14 rounded-2xl bg-accent grid place-items-center mb-4"><Rocket className="h-6 w-6 text-[#255058]" /></div>
        <div className="font-display font-semibold text-lg">Planned for {phase}</div>
        <p className="text-sm text-muted-foreground mt-2 max-w-md">
          This module is part of the Nexreq ATS roadmap and will be built in a later phase. The foundation, data model and permissions are already in place to support it.
        </p>
      </Card>
    </div>
  );
}
